import { forEach, indexOf } from 'lodash';
import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export function priorPeriodUsersReducer(
	state = initialstate.priorPeriodUsers,
	action
) {
	switch (action.type) {
		case types.GET_PRIOR_PERIOD_USERS_LIST: {
			if (!action) return state;

			action.response.users = action.response.users?.filter((user) => !user.gui.includes('@'));

			action.response.users.forEach(function(item) {
				item.isSelected = false;
			});

			return action.response;
		}
		case types.SET_ENGAGEMENT_USER_ROLE: {
			if (!action || !action.user.role || !action.user) return state;

			let newstate = _.cloneDeep(state);

			let index = newstate.users.findIndex(
				(user) => user.userId === action.user.userId
			);
			if (index !== -1) {
				newstate.users[index].engagementRoleId = action.user.role.index;
				newstate.users[index].engagementRole = action.user.role.label;
			}

			return newstate;
		}
		case types.ADD_SELECTED_USER: {
			if (!action.user) return state;

			let newstate = _.cloneDeep(state);	

			action.user.forEach((userId)=>{
				let index = newstate.users.findIndex((user)=> user.userId === userId);
				if (index !== -1) {
					newstate.users[index].isSelected = true;
				}
			})
			
			return newstate;
		}

		case types.REMOVE_SELECTED_USER: {
			if (!action.user) return state;
			
			let newstate = _.cloneDeep(state);

			action.user.forEach((userId)=>{
				let index = newstate.users.findIndex((user)=> user.userId === userId);
				if (index !== -1) {
					newstate.users[index].isSelected = false;
				}
			})

			return newstate;
		}

		case types.ADD_ALL_USER: {
			if (!action.user || action.user === undefined) return state;

			let newstate = _.cloneDeep(state);

			newstate.users.map((item) => {
				item.isSelected = true;
			});

			return newstate;
		}
		case types.CLEAR_ALL_USERS: {
			return {};
		}
		
		default:
			return state;
	}
}
